import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {UserJwt} from '../../../models/admin_owner/user/user-jwt';
import {FormsGateStatus} from '../shared/models/forms-gate-status.model';

/**
 * Talks to the **monolith's** required-forms gate endpoints (`/auth/forms-gate/*`) — note these live on the
 * monolith origin (the SPA's single BASE_URL), not the Forms microservice. Both are reachable while the session
 * is `restricted` (whitelisted by `FormsGateMiddleware`). The AuthInterceptor attaches the bearer; `reissue`
 * additionally needs the CM-Secret cookie, hence `withCredentials`.
 */
@Injectable({providedIn: 'root'})
export class FormsGateHttpService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
  }

  /** The current employee's required-forms status (verdict + missing form keys + flagged + deadlines). */
  status(): Observable<FormsGateStatus> {
    return this.http.get<FormsGateStatus>(`${this.baseUrl}/auth/forms-gate/status`, {withCredentials: true});
  }

  /** Re-evaluate the gate and mint a fresh token for the current employee (live upgrade, no re-login). */
  reissue(): Observable<UserJwt> {
    return this.http.post<UserJwt>(`${this.baseUrl}/auth/forms-gate/reissue`, {}, {withCredentials: true});
  }
}
